import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { IosUploadDialogComponent } from './ios-upload-dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		A11yModule
	],
	declarations: [
		IosUploadDialogComponent
	],
	exports: [
		IosUploadDialogComponent
	]
})
export class IosUploadDialogModule {}
